import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	closeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButtonIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeLabel: {
		id: 'assets-graph-header.close-label',
		defaultMessage: 'Close',
		description: 'Label for button that closes the CMDB Object graph view',
	},
	closeButtonIcon: {
		id: 'assets-graph-header.close-button-icon',
		defaultMessage: 'Close Button Icon',
		description: 'Icon button label for the close object graph modal',
	},
});
export default messages;
